import React from "react";
import {
  CreateQuestionShortHeader,
  CreateQuestionShortHeaderNoInput,
} from "./QuestionShort";

const QuestionCreateHeader = ({ data, setData }) => {
  const renderHeader = () => {
    const { type } = data;

    const componentMap = {
      short: CreateQuestionShortHeader,
      scale: CreateQuestionShortHeader,
      multiple: CreateQuestionShortHeader,
      checkbox: CreateQuestionShortHeader,
      bodyweight: CreateQuestionShortHeaderNoInput,
      progress: CreateQuestionShortHeaderNoInput,
      nutrition: CreateQuestionShortHeaderNoInput,
      steps: CreateQuestionShortHeaderNoInput,
      sleep: CreateQuestionShortHeaderNoInput,
      hrv: CreateQuestionShortHeaderNoInput,
      measurement: CreateQuestionShortHeaderNoInput,
    };

    const Component = componentMap[type] || CreateQuestionShortHeader;

    return (
      <Component
        data={data}
        setData={setData}
        title={data.title}
        key={`header-${type}`}
      />
    );
  };

  return renderHeader();
};

export default QuestionCreateHeader;
